<template>
  <div class="deviceDistrbution">
    <div class="amap-page-container">
      <el-amap vid="amap" :plugin="plugin" class="amap-demo">
        <el-amap-marker v-for="(marker,index) in markers" :key="index" :position="marker.position" :events="marker.events" :zooms="zoom"></el-amap-marker>
         <el-amap-info-window v-if="window" :position="window.position" :visible="window.visible" :content="window.content" :offset="window.offset" ></el-amap-info-window>
      </el-amap>
    </div>
    
  </div>
</template>
<script>
import { getStorePosition } from "../../api/devicestatics/deviceDistribution.js";
import VueAMap  from 'vue-amap'
export default {
  name: "DeviceDistrbution",
  data() {
    return {
      windows:[],
      window:'',
      zoom: 3,
      storePosition: "",
      drawer: false,
      direction: 'rtl',
      storeInfo:'', 
      geolocation: '',
      getLatitude: '',
      lng: 0,
      lat: 0,
      markers: [],
      loaded: false,
      plugin: [
        {
          enableHighAccuracy: true, //是否使用高精度定位，默认:true
          timeout: 500, //超过10秒后停止定位，默认：无穷大
          maximumAge: 300000, //定位结果缓存0毫秒，默认：0
          convert: true, //自动偏移坐标，偏移后的坐标为高德坐标，默认：true
          showButton: true, //显示定位按钮，默认：true
          buttonPosition: "RB", //定位按钮停靠位置，默认：'LB'，左下角
          showMarker: true, //定位成功后在定位到的位置显示点标记，默认：true
          showCircle: true, //定位成功后用圆圈表示定位精度范围，默认：true
          panToLocation: true, //定位成功后将定位到的位置作为地图中心点，默认：true
          zoomToAccuracy: true, //定位成功后调整地图视野范围使定位位置及精度范围视野内可见，默认：f
          resizeEnable:true,
          extensions: "all",
          pName: "Geolocation",
        },
      ],
    };
  },
  methods: {
    getStoreInfo(){
      getStorePosition().then((result) => {
      let markers = [];
      let that = this;
      let windows = [];
      result.data.forEach((item,index) => {
      markers.push({
          position: [item.longitude, item.latitude],
          events: {
            mouseover() {
              that.windows.forEach(window=>{
                window.visible = false;
              })
              that.window = that.windows[index];
              that.$nextTick(()=>{
                that.window.visible = true;
              })
            }
          }
        });
        let content = "<div style='width:300px;'>"+
                        "<table>"+
                          "<tr>"+
                            "<td style='width:50px'>门店名称</td>"+
                            "<td colspan='3'>"+item.storeName+"</td>"+
                          "</tr>"+
                          "<tr>"+
                            "<td>门店地址</td>"+
                            "<td colspan='3'>"+item.address+"</td>"+
                          "</tr>";
        item.deviceIds.forEach(device=>{
          content+="<tr>"+
          "<td>设备编号</td>"+
          "<td>"+device.deviceId+"</td>"+
          "<td>设备状态</td>"+
          "<td>"+device.onLine+"</td>"+
          "</tr>"
        })
        content+="</table></div>"
        windows.push({
          position: [item.longitude, item.latitude],
          content: content,
          offset: [5,-15],
          visible: false
        })
      })
      this.markers = markers;
      this.windows = windows;
      });
    },
    getDeviceId(deviceIds){
      let deviceId = "";
      deviceIds.forEach(item=>{
        deviceId+="设备编号："
        deviceId+=item.deviceId
        deviceId+="  状态:"
        deviceId+=item.onLine
      })
      return deviceId;
    }
  },
  created() {
    // 初始化vue-amap
    VueAMap.initAMapApiLoader({
      // 高德key
      key: '97e90f547a9eba7ce4660bc3cc26573c',
      // 插件集合 （插件按需引入）
      plugin: ['AMap.Geolocation','AMap.Scale', 'AMap.OverView', 'AMap.ToolBar', 'AMap.MapType','MarkerClusterer'],
      uiVersion: '1.0.11',
      v: '1.4.4',
    });

  },
  mounted() {
   this.getStoreInfo();
  },
};
</script>

<style scoped>
body {
  display: flex;
}
.deviceDistrbution {
  margin: 0px 0px 0px 0px;
  background-color: #f2f2f2;
  width: 100%;
  height: 100%;
}
.amap-page-container {
  height: 100%;
  width: 100%;
}
.amap-demo {
  height: 100%;
  width: 100%;
}
</style>



// WEBPACK FOOTER //
// src/pages/deviceStatics/deviceDistribution.vue